import { Container } from './styles';

interface CardInfosProps {
  value: number | string;
  reference: string;
  icon: string;
}

function CardInfos({ value, reference, icon }: CardInfosProps) {
  return (
    <Container>
      <div className={reference.includes('Base') ? 'base_value' : ''}>
        <img src={icon} alt="Icon" />
        <h2>{reference}</h2>
      </div>
      <h1>{value}</h1>
    </Container>
  );
}

export default CardInfos;
